import { InterZellerMediumFont } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const XeroServiceName = styled.span`
  ${InterZellerMediumFont}
`
